module.exports = __webpack_public_path__ + "img/shutdown_banner.d6e97d6b.png";